export default __webpack_public_path__ + "static/media/beeswax-icon.035244cc.png";